import { render } from "./ProductSalesReport.vue?vue&type=template&id=5fda6484&scoped=true"
import script from "./ProductSalesReport.vue?vue&type=script&lang=js"
export * from "./ProductSalesReport.vue?vue&type=script&lang=js"

import "./ProductSalesReport.vue?vue&type=style&index=0&id=5fda6484&scoped=true&lang=css"

import exportComponent from "D:\\xampp7\\htdocs\\24x7pos\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fda6484"]])

export default __exports__